/*
 *
 *  actions
 *
 */

import {
  LOAD_PAYMENT_IN_DETAILS,
  LOAD_PAYMENT_IN_DETAILS_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_ERROR,
  LOAD_PAYMENT_SETTLED_LIST,
  LOAD_PAYMENT_SETTLED_LIST_SUCCESS,
  LOAD_PAYMENT_SETTLED_LIST_ERROR,
  CREATE_PAYMENT_IN_DETAILS,
  CREATE_PAYMENT_IN_DETAILS_SUCCESS,
  CREATE_PAYMENT_IN_DETAILS_ERROR,
  UPDATE_PAYMENT_IN_DETAILS,
  UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
  UPDATE_PAYMENT_IN_DETAILS_ERROR,
  DELETE_PAYMENT_IN_DETAILS,
  DELETE_PAYMENT_IN_DETAILS_SUCCESS,
  DELETE_PAYMENT_IN_DETAILS_ERROR,
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA,
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_ERROR,
  LOAD_PARTY_ACCOUNT_LIST,
  LOAD_PARTY_ACCOUNT_LIST_SUCCESS,
  LOAD_PARTY_ACCOUNT_LIST_ERROR,

  LOAD_PAYMENT_IN_DETAILS_REPORT,
  LOAD_PAYMENT_IN_DETAILS_REPORT_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_REPORT_ERROR,

} from "./constants";

// load payment in
export function loadPaymentInList(paymentDetails) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS,
    paymentDetails,
  };
}

export function loadPaymentInListSuccess(payment_in_list, success) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_SUCCESS,
    payment_in_list,
    success,
  };
}

export function loadPaymentInListError(error) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_ERROR,
    error,
  };
}
// load parties
export function loadPaymentSettledList(paymentDetails) {
  return {
    type: LOAD_PAYMENT_SETTLED_LIST,
    paymentDetails,
  };
}

export function loadPaymentSettledListSuccess(payment_settled_list, success) {
  return {
    type: LOAD_PAYMENT_SETTLED_LIST_SUCCESS,
    payment_settled_list,
    success,
  };
}

export function loadPaymentSettledListError(error) {
  return {
    type: LOAD_PAYMENT_SETTLED_LIST_ERROR,
    error,
  };
}

//payment in report

// load payment in
export function loadPaymentInReportList(paymentDetails) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_REPORT,
    paymentDetails,
  };
}

export function loadPaymentInReportListSuccess(payment_in_report, success) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_REPORT_SUCCESS,
    payment_in_report,
    success,
  };
}

export function loadPaymentInReportListError(error) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_REPORT_ERROR,
    error,
  };
}

// load account
export function loadPartyAccountList(paymentDetails) {
  return {
    type: LOAD_PARTY_ACCOUNT_LIST,
    paymentDetails,
  };
}

export function loadPartyAccountListSuccess(party_account_list, success) {
  return {
    type: LOAD_PARTY_ACCOUNT_LIST_SUCCESS,
    party_account_list,
    success,
  };
}

export function loadPartyAccountListError(error) {
  return {
    type: LOAD_PARTY_ACCOUNT_LIST_ERROR,
    error,
  };
}

// load parties
export function createPaymentInList(paymentDetails) {
  return {
    type: CREATE_PAYMENT_IN_DETAILS,
    paymentDetails,
  };
}

export function createPaymentInListSuccess(paymentDetails, success) {
  return {
    type: CREATE_PAYMENT_IN_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function createPaymentInListError(error) {
  return {
    type: CREATE_PAYMENT_IN_DETAILS_ERROR,
    error,
  };
}
// load parties
export function updatePaymentInList(paymentDetails) {
  return {
    type: UPDATE_PAYMENT_IN_DETAILS,
    paymentDetails,
  };
}

export function updatePaymentInListSuccess(paymentDetails, success) {
  return {
    type: UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function updatePaymentInListError(error) {
  return {
    type: UPDATE_PAYMENT_IN_DETAILS_ERROR,
    error,
  };
}
// load parties
export function deletePaymentInList(paymentDetails) {
  return {
    type: DELETE_PAYMENT_IN_DETAILS,
    paymentDetails,
  };
}

export function deletePaymentInListSuccess(paymentDetails, success) {
  return {
    type: DELETE_PAYMENT_IN_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function deletePaymentInListError(error) {
  return {
    type: DELETE_PAYMENT_IN_DETAILS_ERROR,
    error,
  };
}

export function loadPaymentInListRecordsMetaData() {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPaymentInListRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPaymentInListRecordsMetaDataError(error) {
  return {
    type: LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadPaymentInList,
  loadPaymentInListSuccess,
  loadPaymentInListError,
  loadPaymentInReportList,
  loadPaymentInReportListSuccess,
  loadPaymentInReportListError,

  loadPartyAccountList,
  loadPartyAccountListSuccess,
  loadPartyAccountListError,

  createPaymentInList,
  createPaymentInListSuccess,
  createPaymentInListError,
  updatePaymentInList,
  updatePaymentInListSuccess,
  updatePaymentInListError,

  deletePaymentInList,
  deletePaymentInListSuccess,
  deletePaymentInListError,

  loadPaymentInListRecordsMetaData,
  loadPaymentInListRecordsMetaDataSuccess,
  loadPaymentInListRecordsMetaDataError,
  loadPaymentSettledList,
  loadPaymentSettledListSuccess,
  loadPaymentSettledListError,
};

export default actions;
